module.exports = __webpack_public_path__ + "media/fonts/Inter-Bold-0eaf807b.ttf";